<!-- eslint-disable vue/multi-word-component-names -->
<!--
 * @Author: yindengli
 * @Date: 2023-09-25 10:36:10
 * @LastEditTime: 2023-10-27 10:49:04
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\components\login\Login.vue
-->
<template>
  <div class="main">
    <div class="login-page">
    <div v-if="curPage == 1" class="login">
      <a-tabs :activeKey="activeKey" @change="onChangeTab">
        <a-tab-pane key="password" tab="密码登录">
          <div class="item account">
            <div class="title">账号</div>
            <a-input class="input-item" v-model="accountValue" placeholder="请输入用户名/手机号码" />
          </div>
          <code-item :codeUrl="CODEURL" ref="codeItem"/>
          <div class="item password">
            <pwd-input titleName="密码" ref="pwd" placeholder="请填写6-20数字、字母至少两种组合"/>
            <!-- <div class="title">密码</div>
            <a-input class="input-item pwdinput" :type="isShowPwd ? 'text' : 'password'" name="password" v-model="passwordValue" placeholder="请填写6-20数字、字母、符号至少两种组合" autocomplete="off"/>
            <img class="pwd-img" :src="pwdImg" @click="handleShowPwd"> -->
          </div>
        </a-tab-pane>
        <a-tab-pane key="code" tab="验证码登录">
          <code-verify ref="phoneLogin"/>
        </a-tab-pane>
      </a-tabs>
      <button class="submit" @click="handleSubmit">{{submitTitle}}</button>
    </div>
    <div class="forgotPwd" v-if="curPage == 2">
      <div class="forgotPwd-title">忘记密码</div>
      <code-verify ref="codeVerify"/>
      <button class="submit" @click="handleSubmit">{{submitTitle}}</button>
    </div>
    <div class="resetPwd" v-if="curPage == 3">
      <reset-pwd :loginKey="loginKey" @resetSuc="resetSuc"/>
    </div>
    <div class="bottom" v-if="curPage != 3">
      <div class="register">
        <span>没有账号？</span>
        <a href="https://support.seeyon.com/a_register.html" target="_blank">立即注册</a>
      </div>
      <div class="bottom-title" @click="changeLoginOrPassword">{{changeTitle}}</div>
    </div>
    <div class="bottom" v-if="curPage == 1">
      <div>
        <span>账号密码与（客户服务云平台）相同，使用协同云平台账号密码登录。</span>
      </div>
    </div>
    </div>

  </div>

</template>

<script>
import CodeItem from './code-item.vue';
import CodeVerify from './codeVerify.vue';
import ResetPwd from './resetPwd.vue';
import pwdInput from './pwdInput.vue'

import eventBus from '@/utils/eventBus'
import axios from 'axios';
import qs from 'qs';
import { setCookie } from "@/utils/common";

import BASEURL from '../../../config/openseeyon'

export default {
  components : {
    CodeItem,
    CodeVerify,
    ResetPwd,
    pwdInput
  },
  props: {
    isShare: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeKey: "code",
      curPage: 1, // 当前页面，1：登录页面，2：忘记密码页面，3：忘记密码页面2
      submitTitle: "登录",
      changeTitle: "忘记密码", // 切换忘记密码和登录
      accountValue: "", // 账号
      passwordValue: "", // 密码
      pwdImg: require("../../assets/imgs/ico2.png"),       
      isShowPwd: false, // 是否显示密码
      loginKey: "", // 登录成功返回的key
      CODEURL: BASEURL.baseUrl + "/seeyon/system/v2/p/getCaptcha",
    };
  },
  computed: {
    backPath(){
      return this.$route.query.back_path || '';
    }
  },
  created() {
    window.location.replace(`${process.env.VUE_APP_cloudUrl}/c/login?back_url=`+encodeURIComponent(window.location.origin +'/#/' + this.backPath) + '&type=open');
  },
  methods: {
    /**
     * 切换登录
     */
    onChangeTab(val) {
      this.activeKey = val;
    },
    /**
     * 获取手机验证码
     */
    getPhoneCode() {
      console.log("getPhoneCode");
    },
    /**
     * 提交登录
     */
    handleSubmit() {
      if (this.curPage == 1 && this.activeKey == "code") {
        // 验证码登录
        const value = this.$refs.phoneLogin && this.$refs.phoneLogin.getCodeVerifyValue();

        // 调用登录接口
        this.postApi(value, BASEURL.baseUrl + "/seeyon/userInfo/v2/getphoneOpenLogin", 1);
        
      } else if (this.curPage == 1 && this.activeKey == "password") {
        // 账号密码登录
        const codeValue = this.$refs.codeItem && this.$refs.codeItem.getCodeValue();
        const pwdStr = this.$refs.pwd && this.$refs.pwd.getPwdValue();
        const data = {
          userName: this.accountValue,
          password: pwdStr,
          codeKey: codeValue.codeKey,
          value: codeValue.graphValue
        };
        this.postApi(data, BASEURL.baseUrl + "/seeyon/userInfo/v2/openLogin", 1);
      } else if (this.curPage == 2) {
        // 忘记密码
        let value = this.$refs.codeVerify && this.$refs.codeVerify.getCodeVerifyValue();
        this.postApi(value, BASEURL.baseUrl +  "/seeyon/userInfo/v2/getphoneOpenLogin", 2)
      }
    },
    /**
     * 发送post请求接口
     * value：接口传参
     * url：接口地址
     * type: 1：登录接口、2：忘记密码手机号发送验证码、3：重置密码
     */
    postApi(value, url, type) {
      console.log('url--->', url)
      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      axios.post(url, qs.stringify(value))
      .then(res => {
        if (res && res.data && res.data.success) {
          // 登录成功
          if (type == 1) {
            this.$message.success({content: '登录成功'});
            // this.getSendQuestionRes(res.data.data);
            this.loginSuccess(res.data.data);
            
          } else if (type == 2) {
            // 忘记密码手机号发送验证码
            this.loginKey = res.data.data
            this.curPage = 3;
          }
          
        } else {
        //  this.curPage = 3;
          if (res && res.data && res.data) {
            this.$message.error(res.data.message);
          } else {
            this.$message.error("登录失败");
          }
        }
      });
    },
    /**
     * 处理登录成功
     */
    loginSuccess(data) {
      setCookie("loginKey", data);
      this.loginKey = data;
      eventBus.$emit("loginSuccess", this.isShare);
      if (this.isShare) {
        this.$emit("loginSuccess", this.loginKey);
      }
    },
    /**
     * 设置登录key值的Cookie
     */
    setLoginKeyCookie(key, value, exDays) {
      const date = new Date();
      date.setTime(date.getTime() + exDays * 24 *60 * 1000);
      const expires = 'expires=' + date.toGMTString();

      document.cookie = key + '=' + value + ';' + expires;
    },
    /**
     * 切换“忘记密码”和“去登录”
     */
    changeLoginOrPassword() {
      switch(this.curPage) {
        case 1: // 登录页面
          this.curPage = 2;
          this.changeTitle = "去登录";
          this.submitTitle = "下一步";
  
          break;
        case 2: // 忘记密码页面
          this.curPage = 1;
          this.changeTitle = "忘记密码";
          this.submitTitle = "登录";
          break;
          
      }
    },
    /**
     * 是否显示密码
     */
    handleShowPwd() {
      this.isShowPwd = !this.isShowPwd;
      if (this.isShowPwd) {
        this.pwdImg = require("../../assets/imgs/ico5.png");
      } else {
        this.pwdImg = require("../../assets/imgs/ico2.png");
      }
    },
    /**
     * 重置密码成功
     */
    resetSuc() {
      console.log("kkkkkk")
      this.curPage = 1;
      this.changeTitle = "忘记密码";
      this.submitTitle = "登录";
    },
    /**
     * 反馈结果查询
    */
   getSendQuestionRes(token) {
      let url = '/faq/problemFeedback/findMyNewFeedback';
      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      axios.defaults.headers.token = token;
      axios.get(url).then(res => {
        console.log('res--->getSendQuestionRes', res)
        if (!res) return;
        const resData = res.data;
        if (resData.code == 0) {
          let msg = '';
          let list = resData.data;
          if (list.length > 0) {
            sessionStorage.setItem('infoNumber', list.length)
            list.forEach(item=> msg+=item.feedback);
            this.$message.success({ content: msg })
          }
        } else {
          this.$message.warning({ content: resData.msg })
        }
        
      })
   },
  }
   
};
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 150px;
}
.login-page {
  width: 45%;
}
.login {
  padding: 0 55px;
}
.item {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
}
.input-item {
  border: 1px solid #d7d7d7;
  background: #f7f7f7;
  padding: 0 15px;
  line-height: 48px;
  height: 50px;
  overflow: hidden;
  position: relative;
}
.title {
  width: 80px;
  max-width: 80px;
  min-width: 80px;
  line-height: 52px;
  display: block;
  float: left;
  font-size: 16px;
  text-align: right;
  padding-right: 4px;
}
.img-code {
  margin-left: 10px;
  margin-bottom: 12px;
}

.password {
  position: relative;
  width: 100%;
  height: 50px;
}
.pwdinput {
  padding-right: 40px;
}
.pwd-img {
  position: absolute;
  width: 22px;
  height: 19px;
  right: 15px;
  top:15px;
  cursor: pointer;
}
.submit {
  border-radius: 40px;
  width: 100%;
  color: #fff;
  background-color: #40a9ff;
  border-color: #40a9ff;
  border: none;
  height: 45px;
  font-size: 16px;
  cursor: pointer;
}
.bottom {
  margin: 30px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 65px;
  font-size: 16px;
}
.bottom-title {
  cursor: pointer;
  color: #40a9ff;
}
.forgotPwd {
  padding: 20px 55px 0px;
}
.forgotPwd-title {
  text-align: center;
  font-size: 26px;
  margin-bottom: 30px;
}

::v-deep .ant-tabs-nav .ant-tabs-tab {
  font-size: 20px;
}
::v-deep .ant-tabs-nav-scroll {
  display: flex;
  justify-content: center;
}
::v-deep .ant-tabs-bar {
  border-bottom: 0px;
  margin: 0 0 25px 0;
}
::v-deep .ant-input-group > .ant-input:first-child {
  border: 1px solid #d7d7d7;
  background: #f7f7f7;
  padding: 0 15px;
  line-height: 48px;
  height: 50px;
  overflow: hidden;
  position: relative;
}
::v-deep .ant-btn-primary {
  height: 50px;
}
::v-deep .ant-modal-content {
border-radius: 40px;
}

@media screen and (max-width: 1024px) {
  .input-item {
    height: 40px;
  }
  .title {
    font-size: 14px;
    max-width: 60px;
    min-width: 60px;
    line-height: 40px;
    text-align: right;
    padding-right: 3px;
  }
  .login {
    padding: 0 10px;
  }
  .login-page {
    padding: 0;
    width: 95%;
  }
  .img-code {
    width: 60px;
    height: 20px;
  }
  .sx-link {
    width: 40px;
    height: 25px;
  }
  
  ::v-deep .ant-tabs-nav .ant-tabs-tab {
    font-size: 16px;
    margin: 0px;
 }
 ::v-deep .ant-input-group > .ant-input:first-child {
  height: 40px;
  font-size: 14px;
 }
 ::v-deep .ant-btn-primary {
  height: 40px;
}
::v-deep .ant-btn-lg {
  font-size: 14px;
  padding: 0 10px
}
}
</style>
